import request from './request';
import coupon from '../services/gma/coupon';
import {GMI, STATE} from '../constants';
import {batchActions} from '../utils/redux';

/**
 * @private
 * @desc Break apart coupon details response and store separately in store based on coupon code
 * @param {Object} resp {coupon_details, messages}
 * @return {Function}
 */
function onGetCouponDetailsSuccess(resp) {
  return dispatch => {
    if (!resp.messages && resp.coupon_details) {
      return dispatch(batchActions(...resp.coupon_details.map(coupon => ({
        type: GMI.SET_GMI_STATE,
        path: STATE.GMA.COUPON.DETAILS.concat([coupon.code]),
        value: coupon
      }))));
    }
    return resp;
  };
}

/**
 * @name getCouponDetails
 * @desc Request GMA content/couponDetails by array of codes, let success function handle where to store the response
 * @param {Object} [data] {payload: {coupons: Array}}
 * @param {Object} [requestOpts]
 * @returns {Function}
 * @memberof actions.content
 * @example
 * store.dispatch(actions.content.getCouponDetails());
 * // Will store details in state.gmi.gma.coupon.details[coupon.code], for each coupon code in the data array
 */
export function getCouponDetails(data, requestOpts) {
  return dispatch => {
    return dispatch(request({
      service: coupon.details,
      opts: requestOpts,
      data
    }))
      .then(resp => dispatch(onGetCouponDetailsSuccess(resp)));
  };
}
